import type { OpenerSlot } from "../match/draft.ts";

const LABELS: Record<OpenerSlot, string> = {
  striker: "Striker",
  nonStriker: "Non-striker",
  bowler: "Bowler",
};

/**
 * The three opening picks, each one tap from being changed, shown above the pad until the first
 * ball. Changing a wrong opener used to mean undoing all three and picking them again; now it is
 * the one that is wrong, and the other two stay. Once a ball is bowled the strip is gone, and a
 * change is a correction from the ball's edit sheet instead.
 */
export function OpenersStrip({
  names,
  onChange,
}: {
  /** Who holds each slot now. A slot with no one in it is not shown. */
  readonly names: Readonly<Record<OpenerSlot, string | null>>;
  readonly onChange: (slot: OpenerSlot) => void;
}): React.ReactElement {
  const slots = (["striker", "nonStriker", "bowler"] as const).filter((slot) => names[slot] !== null);
  return (
    <section className="openers-strip" aria-label="Openers">
      <p className="openers-strip__title">Openers — tap one to change it. Gone after the first ball.</p>
      <div className="openers-strip__grid">
        {slots.map((slot) => (
          <button
            key={slot}
            className="opener"
            aria-label={`Change ${LABELS[slot].toLowerCase()}, now ${names[slot]}`}
            onClick={() => onChange(slot)}
          >
            <span className="opener__role">{LABELS[slot]}</span>
            <span className="opener__name">
              <span>{names[slot]}</span>
              <i className="opener__edit" aria-hidden="true">✎</i>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
}
